import { render, staticRenderFns } from "./SaleReturnProductsList.vue?vue&type=template&id=1d7d9748&scoped=true"
import script from "./SaleReturnProductsList.vue?vue&type=script&lang=js"
export * from "./SaleReturnProductsList.vue?vue&type=script&lang=js"
import style0 from "./SaleReturnProductsList.vue?vue&type=style&index=0&id=1d7d9748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7d9748",
  null
  
)

export default component.exports